import {ofType} from 'redux-observable'
import {ajax} from 'rxjs/ajax';
import {EMPTY, of} from 'rxjs';
import i18next from 'i18next';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators'

import {
    LOG_IN_REQUEST_START,
    logInRequestFail,
    logInRequestSuccess,
    LOGOUT_REQUEST_START,
    logoutRequestFail,
    logoutRequestSuccess,
    LOG_IN_REQUEST_SUCCESS,
} from '../actions/Auth'
import {SHOPS_SELECT_SHOP} from "../actions/Shops";
import {eventsSetUserId} from "../Components/utils";
import {getPersonalInfo} from "../thunks/Settings";


export const logInRequestEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOG_IN_REQUEST_START),
        mergeMap(
            action => ajax.post(
                process.env.REACT_APP_API_URL + 'auth/login/',
                {
                    "email": action.email,
                    "password": action.password,
                },
                {
                    'Content-Type': 'application/json',
                }).pipe(
                map(response => {
                    if (response.response.status === 'ok') {
                        eventsSetUserId(response.response.result.user.id);
                        return logInRequestSuccess(response.response.result.token, response.response.result.user)
                    } else {
                        return logInRequestFail(response.response.errors)
                    }
                }),
                catchError(error => {
                    return of(logInRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request')
                    }));
                })
            )
        )
    );


export const logOutEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_START),
        switchMap(
            action => ajax.post(
                process.env.REACT_APP_API_URL + 'auth/logout/',
                {},
                {
                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                    'Content-Type': 'application/json',
                }
            ).pipe(
                map(response => {
                    if (response.status === 204) {
                        eventsSetUserId(null);
                        return logoutRequestSuccess()
                    } else {
                        return logoutRequestFail(response.response.errors)
                    }
                }),
                catchError(error => {
                    return of(logoutRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                    }));
                }),
            )
        )
    );


export const setGlobalUserData = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_SELECT_SHOP),
        switchMap(
            () => {
                window.s2bUserID = state$.value.Auth.user.id;
                window.s2bUserEmail = state$.value.Auth.user.email;

                // Set Yandex metrika data
                if (window.ym && window.yandexMetrikaID) {
                    window.ym(window.yandexMetrikaID, 'userParams', {
                        UserID: state$.value.Auth.user.id,
                        UserEmail: state$.value.Auth.user.email,
                    });
                }

                return EMPTY;
            }
        )
    );


export const getPersonalInfoEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOG_IN_REQUEST_SUCCESS),
        switchMap(
            () => of(getPersonalInfo())
        )
    );